import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=c2b7fb12&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=c2b7fb12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b7fb12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2b7fb12')) {
      api.createRecord('c2b7fb12', component.options)
    } else {
      api.reload('c2b7fb12', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=c2b7fb12&scoped=true&", function () {
      api.rerender('c2b7fb12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OOriInJpH0Xz/JS/comp/Voucher.vue"
export default component.exports